import React, { useState, useEffect } from "react";
import Header from "../../Core/Header";
import axios from "axios";
import { userAdd, userList, userOtp, userOtpVerify } from "../../Services/Operations/ProductAPI";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { setLoginData } from "../../Redux/user_information";
import { useNavigate } from "react-router-dom";
import { Section } from "../../Core/Section";
import { useSelector } from "react-redux";
import { Button, Modal } from "react-bootstrap";

const User = () => {
  const token = useSelector((state) => state.user.token);
    const [showOtpSection, setShowOtpSection] = useState(false);
  const [otp, setOtp] = useState(["", "", "", ""]);
  console.log("token : ", token);
  const [user, setUser] = useState([]);
  const [profileImage,setProfileImage]=useState(null)
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const[showModal,setShowModal]=useState(false)
  const [selectedUser,setSelectedUser]=useState(null)
  const [cartUpdated, setUserUpdated] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    dob: "",
    age: "",
    gender: "",
    co: "",
    houseBuildingApartment: "",
    streetRoadLane: "",
    landmark: "",
    areaLocalitySector: "",
    villageTownCity: "",
    postOffice: "",
    district: "",
    subDistrict: "",
    state: "",
    pincode: "",
    primaryNumber: "",
    secondaryNumber: "",
    email: "",
   
  });

  const[searchKey,setSearchKey]=useState("")

      const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    
    const indexOfLast = currentPage * itemsPerPage;
    const indexOfFirst = indexOfLast - itemsPerPage;
    
    const currentUsers = user.filter(i=>i.firstName.includes(searchKey) || i.lastName.includes(searchKey)).slice(indexOfFirst, indexOfLast);

    //firstName} ${user?.lastName

   const handleViewDetails = (user) => {
    setSelectedUser(user);
    setShowModal(true);
  };
  const handleCloseModal=()=>{
    setShowModal(false)
    setSelectedUser(null)
  }

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
   
    try {
       const response = await userOtp(formData?.primaryNumber, token);
       console.log("response of user added:", response);
       if (response.status === 200) {
         console.log("don1", response.data.id);
          toast.success(response.data);
        //  dispatch(setLoginData(response.data.id));
          setShowOtpSection(true);
        //  setUserUpdated((prev) => !prev);
       } else {
         console.log("don", response.message);
         toast.error(response.data.message);
       }
       
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    const fetchUserList = async () => {
      try {
        const response = await userList(token);
        console.log("user list:", response);
         const found = response.find(item =>
    item.categories?.some(c => c.categoryname === "Admin")
  );
    const newList = response.filter(item => item !== found);
        setUser(newList);
      } catch (error) {
        console.error("Error updating profile:", error);
      }
    };

    fetchUserList();
  }, [cartUpdated]);

  const handleAddRole = (id) => {
    console.log("Id : ", id);
    navigate("/user-allocation", { state: { userSelectId: id } });
  };

    const handleOtpChange = (index, value) => {
    if (!/^\d?$/.test(value)) return; // Only allow digits
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      const nextInput = document.getElementById(`otp-${index + 1}`);
      if (nextInput) nextInput.focus();
    }
  };

 const handleOtpSubmit = async () => {
  const enteredOtp = otp.join("");
  const phone = formData.primaryNumber;

  if (enteredOtp.length === 4 && phone) {
    try {
      const formDataToSend = new FormData();
       formDataToSend.append('profileImageFile',profileImage)
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });
 console.log("formDataToSend",formDataToSend);
 
      formDataToSend.append("otp", enteredOtp);
      const result = await userAdd(formDataToSend, token);
      console.log("OTP verification response:", result);
      if (result.status === 200) {
         console.log("don1", result.data.id);
          toast.success("User added successully");
          dispatch(setLoginData(result.data.id));
          setUserUpdated((prev) => !prev);
          navigate('/')
       } else {
         console.log("don", result.message);
         toast.error(result.data);
       }
       
    } catch (error) {
      console.error("Error verifying OTP:", error);
    }
  } else {
    alert("Please enter a valid phone number and a 6-digit OTP");
  }
};







  return (
    <div id="main_content">
      <Header />
      <div className="page">
        <Section />
        <div className="section-body">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center ">
              <div className="header-action">
                <h1 className="page-title">Users</h1>
                <ol className="breadcrumb page-breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#">RNDSAN</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Users
                  </li>
                </ol>
              </div>

                <input style={{width:"290px",outline:"none"}} placeholder="Search users first / last name"
                value={searchKey} onChange={(e)=>setSearchKey(e.target.value)}/>
              <ul className="nav nav-tabs page-header-tab">
             \
               
                <li className="nav-item">
                  <a
                    className="nav-link active"
                    data-toggle="tab"
                    href="#Student-all"
                  >
                    List View
                  </a>
                </li>
              
              
              </ul>
            </div>
          </div>
        </div>
        <div className="section-body mt-4">
          <div className="container-fluid">
            <div className="tab-content">
              <div className="tab-pane active" id="Student-all">
              
                <div className="table-responsive card">
                  <table className="table table-hover table-vcenter table-striped mb-0 text-nowrap">
                    <thead>
                      <tr style={{textAlign:"center"}}>
                        <th>Id</th>
                        <th style={{textAlign:"center"}}>Name</th>
                       
                       
                        
                       
                        <th style={{textAlign:"center"}}>Gender</th>
                        <th style={{textAlign:"center"}}>Email</th>
                        <th style={{textAlign:"center"}}>Phone</th>
                        <th style={{textAlign:"center"}}>State</th>
                        <th style={{textAlign:"center"}}>Role</th>
                        <th style={{textAlign:"center"}}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentUsers?.map((user,index) => (
                        <tr key={user?.id}>
                          <td>{indexOfFirst+index+1}</td>
                         
                         
                          <td>
                            <span className="font-16">{`${user?.firstName} ${user?.lastName}`}</span>
                          </td>
                          
                          <td>{user?.gender}</td>
                          <td>{user?.email}</td>
                          <td>{user?.primaryNumber}</td>
                          <td>{user?.state}</td>
                          <td>
                            <button
                              onClick={() => handleAddRole(user.id)}
                              className="btn btn-primary"
                            >
                              Add
                            </button>
                          </td>
                          <td>
                            <button
                              type="button"
                              className="btn btn-icon btn-sm"
                              title="View"
                              onClick={()=>handleViewDetails(user)}
                            >
                              <i className="fa fa-eye" />
                            </button>
                           
                          
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                      <div className="pagination mt-3" style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
                             <button
    disabled={currentPage === 1}
    onClick={() => setCurrentPage((prev) => prev - 1)}
    className="btn btn-primary btn-sm me-2"
  >
    Prev
                     </button>

                      <span> Page {currentPage} of {Math.ceil(user.length / itemsPerPage)} </span>

                  <button
    disabled={currentPage === Math.ceil(user.length / itemsPerPage)}
    onClick={() => setCurrentPage((prev) => prev + 1)}
    className="btn btn-primary btn-sm ms-2"
  >
    Next
               </button>
</div>
                </div>
              </div>


          


              <div className="tab-pane" id="Student-add">
                <div className="row clearfix">
                  <div className="col-lg-8 col-md-12 col-sm-12">
                    <div className="card">
                      <div className="card-header">
                        <h3 className="card-title">Basic Information</h3>
                        <div className="card-options ">
                        
                        </div>
                      </div>
                       {!showOtpSection ? (
                      <form className="card-body" onSubmit={handleSubmit}>
                        {Object.keys(formData).map((field) => (
                          <div className="form-group row" key={field}>
                            <label className="col-md-3 col-form-label">
                              {field
                                .replace(/([A-Z])/g, " $1")
                                .replace(/^./, (str) => str.toUpperCase())}
                              {field !== "middleName" &&
                              field !== "secondaryNumber" &&
                              field !== "co" &&
                              field !== "landmark" ? (
                                <span className="text-danger">*</span>
                              ) : null}
                            </label>
                            <div className="col-md-9">
                              {field === "gender" ? (
                                <select
                                  className="form-control"
                                  name={field}
                                  value={formData[field]}
                                  onChange={handleChange}
                                  required
                                >
                                  <option value="">Select Gender</option>
                                  <option value="Male">Male</option>
                                  <option value="Female">Female</option>
                                  <option value="Other">Other</option>
                                </select>
                              ) : field === "pincode" ? (
                                <input
                                  type="text"
                                  className="form-control"
                                  name="pincode"
                                  placeholder="Enter pincode"
                                  value={formData["pincode"]}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d{0,6}$/.test(value)) {
                                      handleChange(e);
                                    }
                                  }}
                                  required
                                  maxLength={6}
                                  pattern="^\d{6}$"
                                  title="Pincode must be exactly 6 digits"
                                />
                              ) : field === "co" ? (
                                <input
                                  type="text"
                                  className="form-control"
                                  name="co"
                                  placeholder="Enter co"
                                  value={formData["co"]}
                                  onChange={handleChange}
                                  onKeyPress={(e) => {
                                    if (/\d/.test(e.key)) {
                                      e.preventDefault();
                                    }
                                  }}
                                  pattern="^[A-Za-z\s]+$"
                                  title="Only alphabetic characters and spaces allowed"
                                />
                              ) : field === "dob" ? (
                                <input
                                  type="date"
                                  className="form-control"
                                  name={field}
                                  placeholder="Enter date of birth"
                                  value={formData[field]}
                                  onChange={(e) => {
                                    handleChange(e);

                                    if (e.target.value) {
                                      const birthDate = new Date(
                                        e.target.value
                                      );
                                      const today = new Date();
                                      let age =
                                        today.getFullYear() -
                                        birthDate.getFullYear();
                                      const monthDiff =
                                        today.getMonth() - birthDate.getMonth();

                                      if (
                                        monthDiff < 0 ||
                                        (monthDiff === 0 &&
                                          today.getDate() < birthDate.getDate())
                                      ) {
                                        age--;
                                      }

                                      setFormData((prev) => ({
                                        ...prev,
                                        age: age.toString(),
                                      }));
                                    }
                                  }}
                                  required
                                />
                              ) : field === "age" ? (
                                <input
                                  type="number"
                                  className="form-control"
                                  name={field}
                                  placeholder="Age"
                                  value={formData[field]}
                                  readOnly
                                />
                              ) : (
                                <input
                                  type={
                                    field === "password"
                                      ? "password"
                                      : field === "email"
                                      ? "email":
                                      field==="profileImage"?
                                      "file"
                                      : "text"
                                  }
                                  className="form-control"
                                  name={field}
                                  placeholder={`Enter ${field
                                    .replace(/([A-Z])/g, " $1")
                                    .toLowerCase()}`}
                                  value={formData[field]}
                                  onChange={ handleChange}
                                  required={
                                    field !== "middleName" &&
                                    field !== "secondaryNumber" &&
                                    field !== "co" &&
                                    field !== "landmark"
                                  }
                                />
                              )}
                            </div>
                          </div>
                        ))}

                            <div className="form-group row" >
                            <label className="col-md-3 col-form-label">
                              Profile Image  <span className="text-danger">*</span>
                            </label>
                            <input type='file' onChange={(e)=>setProfileImage(e.target.files[0])}/>
                            </div>

                        <div className="col-sm-12">
                          <button type="submit" className="btn btn-primary">
                            Submit
                          </button>
                        </div>
                      </form>
                       ) : (
        <div className="otp-section card p-4">
          <h4 className="text-center mb-4">Enter OTP</h4>
          <div className="otp-inputs d-flex justify-content-center mb-3">
            {otp.map((digit, index) => (
              <input
              
                id={`otp-${index}`}
                type="text"
                maxLength="1"
                className="otp-box"
                value={digit}
                onChange={(e) => handleOtpChange(index, e.target.value)}
              />
            ))}
          </div>
          <div className="text-center">
            <button className="btn btn-success" onClick={handleOtpSubmit}>
              Verify OTP
            </button>
          </div>
        </div>
      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="section-body">
          <footer className="footer">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  Copyright © 2025{" "}
                  <a href="">Technology support By - Siance Software Pvt Ltd</a>
                  .
                </div>
                {/* <div className="col-md-6 col-sm-12 text-md-right">
                  <ul className="list-inline mb-0">
                    <li className="list-inline-item">
                      <a href="../doc/index.html">Documentation</a>
                    </li>
                    <li className="list-inline-item">
                      <a href="javascript:void(0)">FAQ</a>
                    </li>
                    <li className="list-inline-item">
                      <a
                        href="javascript:void(0)"
                        className="btn btn-outline-primary btn-sm"
                      >
                        Buy Now
                      </a>
                    </li>
                  </ul>
                </div> */}
              </div>
            </div>
          </footer>
        </div>

         <Modal show={showModal} onHide={handleCloseModal} size="md">
                  <Modal.Header closeButton>
                    <Modal.Title>Category Details</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    {selectedUser ? (
                      <div>
                        <p>
                          <strong>ID:</strong> {selectedUser.id}
                        </p>
                        <p>
                          <strong> Name:</strong>{" "}
                          {selectedUser.firstName} {"  "}{selectedUser.middleName}{"  " }{selectedUser.lastName}
                        </p>
                        <p><strong>Assigned Roles:</strong>{" "}
                        {selectedUser.categories && selectedUser.categories.length > 0 && selectedUser.categories.map((role)=>(
                          <span >{role.categoryname},</span>))
                        }
                        </p>
                        <p>
                          <strong>Primary number:</strong>{" "}
                          {selectedUser.primaryNumber}
                        </p>
                        <p>
                          <strong>Email:</strong>{" "}
                          {selectedUser.email}
                        </p>
                         <p>
                          <strong>Date of birth:</strong>{" "}
                          {selectedUser.dob[0]}/{selectedUser.dob[1]}/{selectedUser.dob[2]}
                        </p>
                        <p>
                          <strong>
                            Address:
                          </strong>
                          {selectedUser.houseBuildingApartment},{selectedUser.areaLocalitySector},{selectedUser.pincode}
                        </p>
                      </div>
                    ) : (
                      <p>No details available</p>
                    )}
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                      Close
                    </Button>
                  </Modal.Footer>
                </Modal>
      </div>
    </div>
  );
};
export default User;
